import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.link.id,
    class: _normalizeClass(["link", `color-${ _ctx.link.colorId }`]),
    onClick: $event => (_ctx.candidate ? _ctx.commitCandidate() : _ctx.removeChainLink(_ctx.link.id)),
    style: _normalizeStyle(`grid-area: ${_ctx.link.block.y+1}/${_ctx.link.block.x+1}/${_ctx.blockYEnd(_ctx.link.block)+1}/${_ctx.blockXEnd(_ctx.link.block)+1}`)
  }, null, 14 /* CLASS, STYLE, PROPS */, ["id", "onClick"]))
}